<img src="assets/images/img-gcash-popup.png" alt="" />

<ion-button expand="block" color="primary" (click)="sendMoney()">
  <ion-icon slot="start" src="assets/images/sendmoney.svg" />
  {{ 'tabs.transaction.button.sendMoney' | translate }}
</ion-button>

<ion-icon id="close" name="close-outline" (click)="dismiss()" />
